// @flow
import React from 'react';

type Props = {
	match: Object
}

const PlayersCompare = (props: Props) => {
	const { match } = props;
	return (
		<div>
			<h1>
				Leagues - league_id {match.params.league_id}
				=> PlayersCompare
			</h1>
			<h3>API: </h3>
		</div>
	);
};

export default PlayersCompare;


// WEBPACK FOOTER //
// ./src/pages/league/PlayersCompare.js